import React from "react";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/EndPoint";
import RiderDashboard from "./RiderDashboard";
import AdminDashboard from "./AdminDashboard";
import MerchantDashboard from "./MerchantDashboard";



const Dashboard = () => {
  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });
  return (
    <>
      {userProfileType?.is_rider ? <RiderDashboard /> : userProfileType?.is_merchant ? <MerchantDashboard /> : <AdminDashboard />}
    </>
  );
};

export default Dashboard;
